import React from 'react';
import moment from 'moment';

import { T } from '../../../../../../../../../common/locale/translate';
import DepartureFromGermany from '../../../../../../../common/components/departure_from_germany';

const Details = data => {
  let offer = data.offer;
  return (
    <div className="details">
      <ul className="details-list">
        <li>
          <span className="fa fa-calendar" />
          <span className="label">
            {`${moment
              .unix(offer.departure_date)
              .utc()
              .format('DD.MM')} - ${moment
              .unix(offer.return_date)
              .utc()
              .format('DD.MM')} / ${offer.trip_duration} ${T('days')}`}
          </span>
        </li>
        {offer.flights &&
          offer.flights[0] &&
          offer.flights[0].departure_airport_iata && (
            <li>
              <span className="fa fa-plane" />
              <div className="container">
                <span className="label">
                  {`${offer.flights[0].departure_airport_name} [${
                    offer.flights[0].departure_airport_iata
                  }]`}
                </span>
                {offer.flights[0].is_departure_from_germany && (
                  <DepartureFromGermany tooltip_id={offer.id} />
                )}
              </div>
            </li>
          )}
        {offer.boards &&
          offer.boards.length > 0 && (
            <li>
              <span className="fa fa-cutlery" />
              <span className="label">{offer.boards[0].name}</span>
            </li>
          )}
      </ul>
    </div>
  );
};

export default Details;



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/components/with-hotel/components/details.js